import { observer } from 'mobx-react';
import React from 'react';

import ToolbarReloadButton from 'components/UI/ToolbarReloadButton';
import store from 'stores/RootStore';

// similar to client/src/components/Views/Creative/AdView/AdViewToolbar/ReloadButton.tsx
// except it binds to the current tearsheet
// see comments there

function ReloadButton() {
  const currentTearsheetAd = store.tearsheet?.ads.current;
  const canReload = !!currentTearsheetAd;
  const isLoading = !!currentTearsheetAd?.loading;

  return (
    <ToolbarReloadButton
      disabled={!canReload}
      isBusy={isLoading}
      onClick={() => currentTearsheetAd?.reload()}
    />
  );
}

export default observer(ReloadButton);
